(() => {
  'use strict'

  // Avoid an ancestor :has([open]) selector on the long PDP. Keeping the state on
  // the story grid limits style recalculation to this small module.
  const initialize = (scope = document) => {
    if (!scope?.querySelectorAll) return
    const disclosures = []
    if (scope.matches?.('.sj-commerce-story [data-product-description-disclosure]')) disclosures.push(scope)
    scope.querySelectorAll('.sj-commerce-story [data-product-description-disclosure]').forEach((details) => disclosures.push(details))

    disclosures.forEach((details) => {
      if (details.dataset.storyLayoutInitialized === 'true') return
      const grid = details.closest('.sj-commerce-story__grid')
      if (!grid) return
      const sync = () => { grid.dataset.storyOpen = details.open ? 'true' : 'false' }
      details.addEventListener('toggle', sync)
      details.dataset.storyLayoutInitialized = 'true'
      sync()
    })
  }

  initialize()
  document.addEventListener('shopify:section:load', (event) => initialize(event.target))
  document.addEventListener('shopify:section:reorder', (event) => initialize(event.target))
  document.addEventListener('shopify:section:select', (event) => initialize(event.target))
})()
